// extracted by mini-css-extract-plugin
module.exports = {"container":"moderation-banner_container__uBDS0"};